import { Component, ChangeDetectorRef, OnInit, AfterViewInit, OnDestroy } from '@angular/core';
import { NewRelicService } from '../../../../../../angular-app/projects/brokerage-eapp/src/app/services/newrelic.service';
import { FormGroup, FormArray, AbstractControl } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable, Subject } from 'rxjs';
import { distinctUntilChanged, first, takeUntil } from 'rxjs/operators';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { fadeAnimation } from '../animations';

// models
import { QuestionBase } from 'src/app/models/question-base';

// services
import { QuestionControlService } from '../services/question-control.service';
import { QuestionService } from '../services/question.service';
import { QuestionSubscriptionService } from '../services/question-subscription.service';
import { ProcessorService } from '../services/processor.service';
import { NavigationService } from '../services/navigation.service';
import { ApiService } from 'src/app/services/api.service';

// store
import { AppState } from '../app-reducer';

// utility
import { filter, find, forEach, get, has, isEmpty, pickBy, clone, cloneDeep, every, isObject, isArray, isNull, isEqual } from 'lodash';

// components
import { ModalComponent } from 'src/app/components/modal.component';
import { AppConstants } from '../app.constants';
import { CommonService } from '../services/common.service';
import { invalid } from '@angular/compiler/src/render3/view/util';

@Component({
  selector: 'app-dynamic-form',
  templateUrl: './dynamic-form.component.html',
  animations: [fadeAnimation]
})

export class DynamicFormComponent implements OnInit, AfterViewInit, OnDestroy {
  questions: QuestionBase<any>[] = [];
  questionsView: QuestionBase<any>[] = [];
  questionsAll: QuestionBase<any>[] = [];
  formData: any = null;
  applyForm: FormGroup;
  arrayParents = [];
  validated = false;
  sectionBlock: string;
  currentRoute: string;
  sectionData: any;
  routeSection: any;
  preFillContent: any = null;
  defaultValues: any = null;
  appState$: Observable<any>;
  showPrevButton = true;
  showReplacementDialog = false;
  isEditable: boolean = true;
  userRole: any;
  hiddenQuestions: any[] = [];
  modalRef: any;
  disableButton: boolean = false;
  agentEmailAddress: string;
  isDemo: boolean = false;
  AgentEmailAddress: any;
  AgentLastName: any;
  sectionMenuData: any;
  formVal: any;
  visibleQuestions: any;
  stopCheck: boolean = false;
  private _onDestroy = new Subject();
  counter: number = 0;
  contentData: any;
  menuData: any;
  formValueNew: any;
  oldStatus = false;
  enabledQuestions: any;
  // switch the following to enable/disable field level collaboration
  toggleOpenFields: boolean = true;
  //dependent compounds
  ltcCompounds = new Map([
    ['LTCMedicalConditionsList', 'LTCMedicalConditionsCompound'],
    ['LTCRequiresAssistanceList', 'LTCRequiresAssistanceCompound'],
    ['LTCUsesAssistanceDevicesList', 'LTCUsesAssistanceDevicesCompound'],
    ['LTCFacilitatedLivingList', 'LTCFacilitatedLivingCompound']
  ]);
  //value of compound that exists in parent checklist
  ltcKeyValues = new Map([
    ['LTCMedicalConditionsCompound', 'LTCCognitiveConditions'],
    ['LTCRequiresAssistanceCompound', 'LTCRequiredAssistanceType'],
    ['LTCUsesAssistanceDevicesCompound', 'LTCAssistanceDevicesSetA'],
    ['LTCFacilitatedLivingCompound', 'LTCFacilitatedLivingType']
  ]);
  policyOwnerQuestions = ['PolicyOwnerInsuredNo', 'PolicyOwnerInsured'];
  medicalConditionsMultiselects = ['BloodOrAutoimmuneDisorder', 'BoneJointDisorder', 'Cancer', 'EndocrineOrDiabetes', 'GastrointestinalDisorder', 'HeartOrBloodVessel', 'KidneyBladderBreastReproductive', 'MentalHealthDisorder', 'NeurologicalDisorder', 'RespiratoryDisorder'];

  submitMe: boolean = false;
  invalidFormGroupsExceptRequired = [];

  appId: any;

  transmittalBlock: number;
  disclosuresBlock: number;



  constructor(
    private cdr: ChangeDetectorRef,
    public route: ActivatedRoute,
    public router: Router,
    private store: Store<AppState>,
    public processorService: ProcessorService,
    private navigationService: NavigationService,
    private qcs: QuestionControlService,
    private qs: QuestionService,
    private questionsSubscriptionService: QuestionSubscriptionService,
    public apiService: ApiService,
    private disclosure: MatDialog,
    private appConstants: AppConstants,
    private commonService: CommonService,
    private newRelicService: NewRelicService
  ) {
    
    // section data
    this.sectionData = route.snapshot.data;
    this.appState$ = store.select('sections');
    this.currentRoute = route.snapshot.routeConfig.path;
    this.sectionBlock = this.sectionData.blockName;

    this.showPrevButton = this.sectionBlock !== 'SECTIONAProposedInsured' && this.sectionBlock !== 'IllustrationStart';

    // get questions from state
    this.appState$.pipe(first()).subscribe((state: any) => {

      this.appId = state.appId;

      this.commonService.logAppState(state);

      // questions check
      this.checkForQuestions(state);


      // user role
      this.userRole = state.userRole;

      // get questions for active block
      const section: any = find(state.questions, { Name: this.sectionBlock });

      // add form data to section
      this.formData = state.formData;

      // generate question set
      this.questions = cloneDeep(section.Questions);
      this.questionsView = this.qs.filterSkippedQuestions(this.questions);
      this.questionsAll = state.questions;

      const skippedQuestions = this.questions.filter((x) => !this.questionsView.includes(x));
      skippedQuestions.forEach(sq => {
        this.hiddenQuestions.push(sq.QuestionName);
      });

      this.setDemoStatus(state);

      this.isEditable = this.qs.checkIfEditable(get(section, "QuestionBlockPermissions"), state.userRole, this.isDemo);

      this.setEnabledQuestions(state);

      // prefill
      const applicationContent = get(state, "content") || {};
      this.preFillContent = !isEmpty(applicationContent) ? cloneDeep(applicationContent[this.sectionBlock]) : null;

      // used to inject form with pre-defined default values
      this.defaultValues = this.qs.defaultValues(section, state.userRole);

      // udpate with necessary informatino to prefill arrays
      const preFillArrayMap = this.qcs.generateArrayMap(this.preFillContent);
      preFillArrayMap["nested"] = this.qcs.generateNestedArraysMap(this.preFillContent);

      // create section form
      this.applyForm = this.qcs.toFormGroup(this.questions, false, preFillArrayMap);

      this.clearHiddenQuestionValidation();

      this.visibleQuestions = cloneDeep(this.applyForm.value);
      // sets formVal to initial state form values to match prefilled state when comparing changes on load
      this.formVal = cloneDeep(this.applyForm.value);

      this.updateMenu(state);

      this.oldStatus = this.sectionMenuData.valid;

      this.commonService.logMessage('this.sectionMenuData', this.sectionMenuData);
      this.commonService.logMessage('this.applyForm', this.applyForm);

      const startSignatureBlocks = this.getStartSignatureBlock(state);
      const trigger = state.content.menuData.filter((x, y) => y < startSignatureBlocks && !x.valid && x.visible);
      const allValid = (trigger.length === 1 && trigger[0].name === this.sectionBlock) || trigger.length === 0;
      // checks whether the current block the last one available in the case and disables the next button if so
      this.applyForm.statusChanges.pipe(distinctUntilChanged()).subscribe(status => {
        if(status === "VALID" && !allValid) {
          this.processorService.notifyFormChange("INVALID");
         // this.updateButtonStatus(allValid);
        } else {
          const triggerAfterStatusChange = state.content.menuData.filter((x, y) => y < startSignatureBlocks && !x.valid && x.visible);
          const allValidAfterStatusChange = (triggerAfterStatusChange.length === 1 && triggerAfterStatusChange[0].name === this.sectionBlock) || triggerAfterStatusChange.length === 0;
          if(!allValidAfterStatusChange) {
            this.processorService.notifyFormChange("INVALID");
          //  this.updateButtonStatus(allValidAfterStatusChange);
          } else {
          this.processorService.notifyFormChange(status);
          }
        }
      });
      const isLastBlock = state.content.menuData.filter((x, y) => y <= startSignatureBlocks && x.visible !== false).pop().name === this.sectionBlock;
     
      if (isLastBlock) {
       
        this.navigationService.disableButton(true);
        const trigger = state.content.menuData.filter((x, y) => y < startSignatureBlocks && !x.valid && x.visible);
        const allValid = (trigger.length === 1 && trigger[0].name === this.sectionBlock) || trigger.length === 0;
        // enables/disables next button based on form validity
        if (allValid) {
          this.updateButtonStatus(allValid);
        }
      } else {
        this.navigationService.disableButton(false);
      }
      
      this.contentData = state.content;
      this.menuData = state.content.menuData;
      this.newRelicService.addPageAction(this.sectionBlock + ' loaded' , { page: this.sectionBlock });
      this.newRelicService.setCurrentRouteName(this.sectionBlock);
      this.newRelicService.setPageViewName(this.sectionBlock);
    });
  }
  updateButtonStatus(allValid) {
    this.applyForm.statusChanges.pipe(takeUntil(this._onDestroy)).subscribe(status => {
      if (status === 'VALID') {
        this.navigationService.disableButton(false);
      } else {
        this.navigationService.disableButton(true);
      }
      if (this.sectionMenuData.valid && status !== 'VALID' || !this.sectionMenuData.valid && status === 'VALID' || !allValid) {
        // window['setTimeout'](() => {
        this.sectionMenuData.valid = status === 'VALID' ? true : null;
        this.navigationService.updateNav(this.applyForm.controls, this.sectionBlock, this.visibleQuestions, allValid);
        // console.log('this.sectionMenuData.valid :', cloneDeep(this.sectionMenuData.valid));
        // console.log('status: ', status);
        window['setTimeout'](() => {
          this.cdr.detectChanges();
        }, 50);
        // }, 150);
      }
    });
  }

  updateMenu(state: any) {
    state.content.menuData.forEach(block => {

      // Seed menu/validation object with current block's questions
      if (block.name === this.sectionBlock) {
        if (block.questions.length === 0) {
          this.questions.forEach((q, i) => {
            const questionStatus = { 'name': q.QuestionName, 'valid': null, 'visible': false };
            block.questions.push(questionStatus);
          });
        }
        this.sectionMenuData = block;
      }
    });
  }

  getStartSignatureBlock(state: any): number {

  const transmittalBlock = state.content.menuData.findIndex(x => x.name == 'TransmittalBlock') ? state.content.menuData.findIndex(x => x.name == 'TransmittalBlock') : 50 ;
  const disclosuresBlock = state.content.menuData.findIndex(x => x.name == 'Disclosures') ? state.content.menuData.findIndex(x => x.name == 'Disclosures') : 35 ;

    return ((this.userRole.name === 'Agent' || this.userRole.name.includes('Owner')) && this.userRole.customerSigned === 1) ? transmittalBlock : disclosuresBlock-1;
  }

  clearHiddenQuestionValidation() {
    this.hiddenQuestions.forEach(hq => {
      if (this.applyForm.get(hq)) {
        this.applyForm.get(hq).clearValidators();
      }
    });
  }

  //set component to demo
  setDemoStatus(state: any) {
    if (state.isDemo) {
      this.isDemo = true;
    }
  }

  //Determines enabled fields on a disabled form based on question permissions
  setEnabledQuestions(state) {
    if (!this.isEditable) {
      this.enabledQuestions = this.qs.filterEnabledQuestions(this.questions, state.userRole, this.isDemo);
      this.commonService.logMessage('this.enabledQuestions: ', this.enabledQuestions);
    }
  }

  //checks app state for questions
  checkForQuestions(state: any) {
    if (!state.questions) {
      this.navigationService.nextSectionRelative('error');
      return false;
    }
  }

  ngOnInit() {
    this.newRelicService.addPageAction('DynamicFormComponent ngOnInit', { status: 'initialized', appId: this.appId });
    // fire subscriptions
    this.questionsSubscriptionService.fireSubscriptions(this.sectionData, this.questions, this.applyForm, this.formData);

    // subscribe to observable used for disabling the "Next" button from child components
    this.navigationService.disableButtonStatus().pipe(takeUntil(this._onDestroy)).subscribe((bool) => {
      this.disableButton = bool;
      this.cdr.markForCheck();
    });

    // write user role to processorService for use in block submissions
    this.processorService.setUserRole(this.userRole.name);
    this.AgentLastName = (window['jhConfig'].lastname !== '') ? window['jhConfig'].lastname : 'Agent';
    this.AgentEmailAddress = (window['jhConfig'].email !== '') ? window['jhConfig'].email : this.agentEmailAddress;

    if (this.preFillContent) {
      this.stopCheck = true;
    }

    // Resets watchForExit trigger for each block. This corrects for the value persisting after exiting a case and entering a new one, which causes blank form submits onload.
    this.navigationService.fireSubmit(false);
    // Watches for a trigger from sibling components and, when received, submits the form. This allows submission on exit.
    this.navigationService.watchForExit().pipe(takeUntil(this._onDestroy)).subscribe(fire => {
      if (fire && this.isEditable) {
        this.submitBlock('exit');
      }
    });

  }

  ngAfterViewInit() {
    this.newRelicService.addPageAction('DynamicFormComponent ngAfterViewInit', { status: 'view initialized', appId: this.appId });
    // set load timestamp for payload submission
    this.processorService.setServedTime();
    this.navigationService.updateNav(this.applyForm.controls, this.sectionBlock, this.visibleQuestions);
    // update form with pre-existing values, except Part2SECTIONCMedicalConditions2 which has its own handling
    if (this.sectionBlock !== "Part2SECTIONCMedicalConditions2") {
      window['setTimeout'](() => {
        this.applyForm.patchValue(this.preFillContent);
        // prevents updating menu navigation status until above patchValue is complete
        window['setTimeout'](() => {
          this.setPolicyOwnerInsured();
          this.stopCheck = false;

          this.menuData.forEach(block => {
            // Populate menu nav with blocks
            this.showConditionalBlock(block);
          });
          if (!this.isEditable) {
            this.disableFields();
          }
          this.checkmarkMenu(this.applyForm.valid || this.applyForm.disabled ? true : null);
          this.cdr.detectChanges();
        }, 250);
      }, 500);

      // cleanup nested arrays
      this.nestedArrayCleanup(this.preFillContent);

    } else if (this.sectionBlock === "Part2SECTIONCMedicalConditions2") {
      window['setTimeout'](() => {
        this.stopCheck = false;
        this.checkmarkMenu(this.applyForm.valid ? true : null);
        this.cdr.detectChanges();
      }, 500);
    }

    //set demo default values
    this.setDemoValues();


    if (this.sectionMenuData.valid === false) {
      this.applyForm.markAllAsTouched();

      window['setTimeout'](() => {
        this.processorService.goToError();
      }, 1000);
    }
    // Watches the form for changes to questions, then performs ConditionalClause analysys on questions listed in ConditionalDependents
    // also used to nullify the question's key in visibleQuestions if it has a ConditionalClause so it gets rechecked on the next change detection cycle
    this.applyForm.valueChanges.pipe(takeUntil(this._onDestroy)).subscribe(value => {
      this.updateFormVal(value);
    });
  }

  //sets policy owner insured for infight cases
  setPolicyOwnerInsured() {
    if (this.sectionBlock == 'SECTIONBPolicyOwner' && !this.isEditable && !this.applyForm.controls['PolicyOwnerInsured'].value && !this.isDemo) {
      this.applyForm.get('PolicyOwnerInsured').setValue('SoleOwner');
      this.submitMe = true;
    }
  }

  setResctrictedLabel() {
    if (this.sectionBlock == 'SECTIONAProposedInsured') {
      if (this.visibleQuestions['StateOfIssueRestrictedLabel'] && this.userRole.name === "Agent") {
        this.visibleQuestions['StateOfIssueRestrictedLabel'] = true;
      } else {
        this.visibleQuestions['StateOfIssueRestrictedLabel'] = false;
      }
    }
  }

  updateFormVal(value: any) {
    try {
  
      let blockChange = false;
      // Clones new value to prevent subsequent updates from changing it before writing to this.formVal
      const newFormVal = cloneDeep(value);
      if (isEqual(this.formVal, newFormVal)) {
        return;
      } else if (this.formVal) {
        const getFormDiff = function (young, old, diffs) {
          forEach(young, (val, key) => {
            if (typeof val === 'string' || typeof val === 'number' || val == null) {
              if (checkValDiff(old, val, key)) {
                diffs.push(key);
              }
            } else if (isArray(val)) {
            // console.log('isArray', val);
              if (checkNonNullObject(val)) {
                val.forEach((subVal, subKey) => {
                  if (old ? old[key] : false) {
                    getFormDiff(subVal, old[key][subKey], diffs);
                  }
                });
            } else if ( (old ? old[key] : false) && checkArrayDiff(old, val, key)) {
                diffs.push(key);
              }
            } else if (isObject(val)) {
              if (checkObjectDiff(old, val, key)) {
              // special handling for one IUL condition that bridges (keep until replaced)
                if (checkIULDiff(old, val, key)) {
                  diffs.push('IULFixedAcct');
                }
                diffs.push(key);
              }
            } else {
              console.log('typeof', typeof val, val);
            }
          });
          return diffs;
        }
        const diff = getFormDiff(newFormVal, this.formVal, []);
  
        if (diff.length > 0) {
        // console.log(diff, 'changed');
          diff.forEach(changedQuestion => {
            if (!this.stopCheck) {
              if (isArray(newFormVal[changedQuestion]) && this.formVal[changedQuestion] != undefined) {

                if (JSON.stringify(newFormVal[changedQuestion]) === JSON.stringify(this.formVal[changedQuestion])) {
                // console.log('*', changedQuestion, 'changed from', cloneDeep(this.formVal[changedQuestion]), 'to', cloneDeep(newFormVal[changedQuestion]));
                  return;
                } else if (this.medicalConditionsMultiselects.includes(changedQuestion)) {
                // Forces left nav updates for Medical Conditions changes
                  const newMaladies = [];
                  forEach(this.medicalConditionsMultiselects, cat => {
                    const categorySelections = this.processorService.getCheckboxValues(this.sectionBlock + '.' + cat, newFormVal[cat], this.questions);
                    forEach(categorySelections, cond => {
                      if (cond !== 'NoneOfTheseApplyToMe') {
                        newMaladies.push(cond);
                      }
                    });
                  });
                // const newMaladies = this.processorService.getCheckboxValues(this.sectionBlock+'.'+changedQuestion, newFormVal[changedQuestion], this.questions);
                  if ('Part2SECTIONCMedicalConditions2' in this.contentData) {
                    this.updateMedCondStatus(newMaladies);
                  }
                } else if (this.ltcCompounds.has(changedQuestion)) {
                // logic for removing the multiresponse answer if the item has been removed from parent question checklist
                // removes the entry for removed name
                  const categorySelections = this.processorService.getCheckboxValues(changedQuestion, newFormVal[changedQuestion], this.questions);
                // console.log('categorySelections: ', categorySelections);

                  const childCompound = this.ltcCompounds.get(changedQuestion);
                  const dependentCompound = this.applyForm.controls[childCompound];
                // console.log('dependentCompound: ', dependentCompound);
                  this.updateLtcDependents(dependentCompound, childCompound, categorySelections);
                }
              }
            //checks if changed question is state of issue, and pops up modal if necessary
              this.stateOfIssueModal(changedQuestion);


              this.checkUpdatePolicyOwnerInformation(changedQuestion, newFormVal);

            }
  
          // console.log(changedQuestion, 'changed from', cloneDeep(this.formVal[changedQuestion]), 'to', cloneDeep(newFormVal[changedQuestion]));
            const question = this.qcs.getQuestion(this.questions, changedQuestion);
          //console.log('question', question);
          // // Prevents analysing conditionality of questions that have data entered but aren't valid (stops repeated unecessary checks)
          // if (this.applyForm.controls[changedQuestion.toString().split('.').pop()].dirty && (!this.applyForm.controls[changedQuestion.toString().split('.').pop()].valid || this.applyForm.controls[changedQuestion.toString().split('.').pop()].value == '$' || !this.applyForm.controls[changedQuestion.toString().split('.').pop()].value)) {
          //    return;
          // }
          // Erase question status in visibleQuestions to allow conditional clause analysis on next Angular change detection cycle
            if (question && question.ConditionalClause) {
              this.visibleQuestions[changedQuestion] = null;
            }
          // Check downstream
            if (question && question.ConditionalDependents && (newFormVal[changedQuestion] !== null || newFormVal[changedQuestion] == null && this.formVal[changedQuestion] != null)) {
              this.checkConditionalDependents(question);
            }
            if (!this.stopCheck) {
            // Update visibility of blocks with Conditional Clauses if they are dependend on current input
              this.menuData.forEach(block => {
                if (block.conditionalClause) {
                  if (JSON.stringify(block.conditionalClause).includes(this.sectionData.blockName) && JSON.stringify(block.conditionalClause).includes(changedQuestion)) {
                  // this.processorService.enableComments(block.name.includes('IllustrationCertification') ? true : false);
                    this.appState$.pipe(first()).subscribe((state: any) => {

                      const section: any = find(state.questions, { Name: block.name });
                      const isViewable = this.qs.checkIfViewable(get(section, "QuestionBlockPermissions"), state.userRole, this.isDemo);
                    // block.visible = isViewable ? this.processorService.isNavBlockVisible(block.conditionalClause, this.applyForm.getRawValue(), this.questions) : false;
                      const showBlock = isViewable ? this.processorService.isNavBlockVisible(block.conditionalClause, this.applyForm.getRawValue()) : false;
                      if (block.visible !== showBlock) {
                        block.valid = (showBlock && block.questions.length > 0) ? false : null;
                      }
                      block.visible = showBlock;
                      blockChange = true;
                    });
                  //const showBlock = this.processorService.isNavBlockVisible(block.conditionalClause, this.applyForm.getRawValue());

                  }
                }
            });
            window['setTimeout'](() => {
              const valid = this.sectionMenuData.valid ? true : false;
              let startSignatureBlocks: any; 
              this.appState$.pipe(first()).subscribe((state: any) => {
                startSignatureBlocks = this.getStartSignatureBlock(state); // Assign value inside the subscription
              });
              var trigger = null;
              var allValid = true;
              if (valid !== this.applyForm.valid || blockChange || this.applyForm.disabled && this.toggleOpenFields) {
                this.sectionMenuData.valid = this.applyForm.valid || this.applyForm.disabled ? true : null;
                //this.checkmarkMenu( this.applyForm.valid ? true : null || this.applyForm.disabled ? true : null);
                  this.appState$.pipe(first()).subscribe((state: any) => {
                    trigger = state.content.menuData.filter((x, y) => y < startSignatureBlocks && !x.valid && x.visible);
                    allValid = (trigger.length === 1 && trigger[0].name === this.sectionBlock) || trigger.length === 0;
                    state.content.menuData.find(x => x.name === this.sectionBlock).valid = this.applyForm.valid || this.applyForm.disabled ? true : null;
                  });
                  this.navigationService.updateNav(this.applyForm.controls, this.sectionBlock, this.visibleQuestions, allValid);
                  this.cdr.detectChanges();
                }
              }, 75);
            }
          });
        }
      }
      this.formVal = newFormVal;
    } catch (error) {
      console.log('error', error);
      this.newRelicService.noticeError(error, { appId: this.appId });
    }
  }


  stateOfIssueModal(changedQuestion: any) {
    if (changedQuestion == 'StateOfIssue' && this.isEditable) {
      const dialogConfig = new MatDialogConfig();
      const modalRef = this.disclosure.open(ModalComponent, {
        disableClose: true,
        closeOnNavigation: true,
        data: {
          size: '',
          // Array of screens
          screens: [
            {
              show: true,
              exit_btn: true,
              content: [
                {
                  type: 'title',
                  content: 'Important:',
                  class: this.appConstants.modalTitleBold,
                  parentClass: 'modal-extra-padding'
                },
                {
                  type: 'text',
                  content: 'State of Issue must match owner state of residence (or state of home office if owner is a business). If there is more than one policy owner, the State of Issue only needs to match residence state for one owner.',
                  class: this.appConstants.modalParagraphDefault
                },
                {
                  type: 'text',
                  content: 'Please note: if the State of Issue and owner residence state do not match, incorrect forms will be generated, and the application will need to be resubmitted.',
                  class: this.appConstants.modalParagraphDefault
                },
                {
                  type: 'button_group',
                  buttons: [
                    {
                      type: 'button',
                      label: 'I Understand',
                      clickFunction: 'close',
                      class: this.appConstants.buttonPrimary
                    }
                  ]
                }
              ]
            }
          ]
        }
      });
    }
  }
  updateMedCondStatus(newMaladies: any) {
    const oldMaladies = this.contentData['Part2SECTIONCMedicalConditions2'].MedicalConditionDetails.map(x => x.ConditionName);
    const medCondDetailsStatus = find(this.menuData, { name: 'Part2SECTIONCMedicalConditions2' });
    if (!newMaladies.every(value => oldMaladies.includes(value)) || !oldMaladies.every(value => newMaladies.includes(value))) {
      medCondDetailsStatus.valid = false;
    } else {
      medCondDetailsStatus.valid = medCondDetailsStatus.valid ? true : null;
    }
  }
  updateLtcDependents(dependentCompound: AbstractControl, childCompound: string, categorySelections: any) {
    if (dependentCompound['controls'] ? (isArray(dependentCompound['controls']) ? true : false) : false) {
      forEach(dependentCompound['controls'], (val, key) => {
        if (val ? val['controls'] : false) {
          // console.log('val[controls] ', val['controls']);
          const currVal = val['controls'][this.ltcKeyValues.get(childCompound)] ? val['controls'][this.ltcKeyValues.get(childCompound)].value : null;
          if (!categorySelections.includes(currVal) && currVal) { //non null values
            if (categorySelections.length >= 1) {
              dependentCompound['controls'].splice(key, 1);
            } else { // nothing checked off in parent check list anymore
              this.resetLtcCompound(val, dependentCompound);
            }
          }
        }
      }
      )
    }
  }
  resetLtcCompound(val, dependentCompound) {
    forEach(val['controls'], (v, k) => {
      if (v.value ? v.value : false) {
        console.log('trying to nullify ', v);
        v.patchValue(null); //nullify the multiresponse
      }
    });
    // if theres more than 1 response, reset to only have one empty multiresponse
    dependentCompound['controls'].splice(1);
  }
  showConditionalBlock(block: any) {
    if (block.conditionalClause) {
      //need to remove the secondary condition once owners permissions in app def are figured out
      if (!block.name.includes('DeclarationsOwner')) {
        //HERE
        this.appState$.pipe(first()).subscribe((state: any) => {

          const section: any = find(state.questions, { Name: block.name });
          const isViewable = this.qs.checkIfViewable(get(section, "QuestionBlockPermissions"), state.userRole, this.isDemo);
          block.visible = isViewable ? this.processorService.isNavBlockVisible(block.conditionalClause, this.applyForm.getRawValue(), this.questions) : false;
        });
        // //var isViewable = this.qs.checkIfViewable(get(section, "QuestionBlockPermissions"), state.userRole, this.isDemo);

        // block.visible = this.processorService.isNavBlockVisible(block.conditionalClause, this.applyForm.getRawValue(), this.questions);
        //console.log('block: ', block.name, 'visible: ', cloneDeep(block.visible), 'with clause: ', block.conditionalClause);
      }
    }
  }

  ngOnDestroy() {
    this._onDestroy.next();
    this.formVal = null;
  }

  checkmarkMenu(val) {
    this.sectionMenuData.valid = val;
    this.cdr.detectChanges();
  }

  disableFields() {
    this.applyForm.disable();
    //console.log('this.questions: ', this.questions);
    if (this.toggleOpenFields) {
      forEach(this.enabledQuestions, q => {
        // console.log('q: ', q);
        // console.log('this.applyForm.get(q): ', this.applyForm.get(q));
        // console.log('this.visibleQuestions[q]: ', this.visibleQuestions[q]);

        if (this.applyForm.get(q) && this.visibleQuestions[q] === true) {
          //console.log('dynamic form enabling: ', q);
          const fullQuestion = this.questions.filter(item => item.QuestionName == q);
          if (this.isDemo && fullQuestion[0].QuestionType == 'Address') {
            this.applyForm.get(q)['controls']['State'].enable();
            this.applyForm.get(q)['controls']['Zip'].enable();
          } else {
            this.applyForm.get(q).enable();
          }
        }
      });
    }
  }

  nestedArrayCleanup(prefill: any) {
    if (!prefill) {
      return true;
    }

    // clone prefill
    const updatedPrefill = window['JSON'].parse(window['JSON'].stringify(prefill));

    // only array items
    const arrayItems = pickBy(updatedPrefill, (value, key) => {
      return isArray(value) && value.length > 0 && every(value, isObject);
    });

    // loop thorugh array items in the form and look for nested arrays
    forEach(arrayItems, (value, key) => {
      const arrayProperty = this.applyForm.get(key) as FormArray;

      // loop through properties
      forEach(arrayProperty.controls, (control: any, index: number) => {
        const arrItems = pickBy(value[index], (val, valKey) => {
          return isArray(val) && val.length > 0 && every(val, isObject);
        });

        if (!isEmpty(arrItems)) {
          this.removeArrayValues(arrItems, control);
        }
      });
    });
  }

  removeArrayValues(arrItems: any, control: any) {
    forEach(arrItems, (value, key) => {
      const formControlLength = control.get(key).length;
      const preFillControlLength = value.length;
      if (formControlLength !== preFillControlLength) {
        const start = preFillControlLength;
        const end = formControlLength - 1;
        for (let step = end; step >= start; step--) {
          control.get(key).removeAt(step);
        }
      }
    });

  }
  isQuestionVisible(question) {
    if (this.hiddenQuestions.includes(question.QuestionName)) {
      this.applyForm.get(question.QuestionName).disable;
      return false;
    } else if (this.visibleQuestions[question.QuestionName] === null || this.visibleQuestions[question.QuestionName].Upload === null || (isArray(this.visibleQuestions[question.QuestionName]) && this.visibleQuestions[question.QuestionName].every(x => x !== true)) || question.QuestionName.includes('NIGOWarning')) {
      this.showConditionalQuestion(question);
    }
    return this.visibleQuestions[question.QuestionName] ? true : false;
  }

  getChildQuestions(question: any) {
    return this.qcs.getChildQuestions(question, this.questions);
  }

  checkBlockEmptyOrUndefined(block) {
    return typeof block === 'undefined' || isEmpty(block.questions) || block === 'undefined';
  }
  checkConditionalDependents(question) {
    const dependentQuestions = question.ConditionalDependents;
    // console.log('dependentQuestions for', question.QuestionName, ':', dependentQuestions);
    dependentQuestions.forEach(q => {
      if (q.toString().toLowerCase().includes(this.sectionBlock.toLowerCase() + '.')) {
        q = q.toString().split('.').pop();
        this.visibleQuestions[q] = null;
      } else {
        const cue = q.toString().split('.');
        const section: any = find(this.questionsAll, { Name: cue[0] });
        this.appState$.pipe(first()).subscribe((state: any) => {
          this.menuData = state.content.menuData;
          const offBlock = find(this.menuData, { name: cue[0] });
          if (this.checkBlockEmptyOrUndefined(offBlock)) {

          } else {
            const offBlockQ = find(offBlock.questions, { name: cue[1] });
            // console.log('offBlock1', cloneDeep(offBlockQ));
            const fullQuestion = this.qcs.getQuestion(section.Questions, cue[1]);
            let showNow: boolean;
            const ancestors = this.getLineage(fullQuestion, section.Questions, []);
            for (let i = 0; i < ancestors.length; i++) {
              // console.log('ancestor being checked:', ancestors[i].QuestionName, ancestors[i]);
              if (!ancestors[i].ConditionalClause) {
                showNow = true;
              } else {
                // this.processorService.enableComments(ancestors[i].QuestionName === 'IllustrationShown' ? true : false);
                showNow = this.processorService.showConditionalQuestion(ancestors[i], section.Questions, this.applyForm.getRawValue());
              }
              if (!showNow) {
                break;
              }
            };
            if (offBlockQ) {
              this.setOffBlockValidity(offBlockQ, showNow, fullQuestion, section);
            }
          }
        });
      }
    });
  }

  setOffBlockValidity(offBlockQ, showNow, question, section) {
    const visibleBefore = clone(offBlockQ.visible);
    if (showNow && question.QuestionName !== 'ConditionName') {
      offBlockQ.visible = true;
      if (question.QuestionType === 'Label') {
        offBlockQ.valid = null;
      } else if (question.QuestionType === 'IllustrationUploadProtectionTerm') {
        offBlockQ.valid = true;
      } else {
        offBlockQ.valid = visibleBefore ? this.checkOffBlockQuestionValidity(question, section.Name) : false;
      }
    } else {
      offBlockQ.visible = false;
      offBlockQ.valid = null;
    }
  }
  getLineage(object, questions, array) {
    array.push(object);
    const { ParentQuestionName } = object;
    if (ParentQuestionName) {
      const question = find(questions, { QuestionName: ParentQuestionName });
      this.getLineage(question, questions, array);
    }
    return array;
  }

  checkOffBlockQuestionValidity(question, sectionName) {
    let result: boolean;
    this.appState$.pipe(first()).subscribe((state: any) => {
      if (state.content[sectionName]) {
        let val = cloneDeep(state.content[sectionName][question.QuestionName]);
        if (question.QuestionType === 'MultiSelect') {
          val = this.processorService.getCheckboxValues(sectionName + '.' + question.QuestionName, val, state.questions.find(x => x.Name === sectionName));
        }
        if (val == undefined && state.content.menuData.find(x => x.name === sectionName).valid) {
          return false;
        }
        if (question.QuestionOptions.length > 0) { // && isArray(val)) {
          if (isArray(val) && val.length > 0) {
            const allValues = [];
            forEach(val, v => {
              const selectedOption = question.QuestionOptions.find(item => item.Name === v.toString());
              if (selectedOption) {
                if (selectedOption.ConditionalClause) {
                  const stillGood = this.processorService.showConditionalOption(selectedOption.ConditionalClause, this.applyForm.getRawValue());
                  if (stillGood === false) {
                    state.content[sectionName][question.QuestionName] = null;
                    allValues.push(false);
                  } else {
                    allValues.push(true);
                  }
                } else {
                  allValues.push(true);
                }
              }
            });
            result = allValues.every(x => x === true);
          } else if (question.QuestionType === 'MultiChoice') {
            const selectedOption = question.QuestionOptions.find(item => item.Name === val);
            // console.log('selectedOptions is', selectedOption);
            if (selectedOption) {
              if (selectedOption.ConditionalClause) {
                const stillGood = this.processorService.showConditionalOption(selectedOption.ConditionalClause, this.applyForm.getRawValue());
                if (stillGood === false) {
                  state.content[sectionName][question.QuestionName] = null;
                  result = false;
                } else {
                  result = true;
                }
              } else {
                result = true;
              }
            }
          } else {
            result = true;
          }
        } else {
          if (question.validators.length === 0) {
            result = true;
          } else {
            // console.log('may need to check these validators:', question.validators);
            result = true;
          }
        }
      } else {
        result = null;
      }
    });
    // console.log('checkOffBlockQuestionValidity result', result);
    return result;
  }

  showConditionalQuestion(question, parentShown: boolean = true, offBlockQuestions?) {
    try {
      this.newRelicService.addPageAction('showConditionalQuestion Start', { status: 'started', questionName: question.QuestionName, appId: this.appId });
  
      const { QuestionName, ConditionalClause } = question;

    // enable console logs for debuggiong all questions (proceed with caution):
    // this.processorService.enableComments(true);
    // enable console logs for debuggiong a specific question:
    // this.processorService.enableComments(QuestionName === 'PrimaryResidenceNIGOWarning' ? true : false);
  
      if (ConditionalClause === '0') {
        parentShown = false;
        this.newRelicService.addPageAction('ConditionalClause Check', { status: 'conditional clause 0', questionName: QuestionName, appId: this.appId });
      }
  
      if (parentShown) {

        // Populate QuestionTextAlt based on AlternativeQuestionText ConditionalClause
        if (question.QuestionVariations) {
          question.QuestionVariations.forEach(cond => {
            if (this.processorService.analyzeConditionalArray(cond.ConditionalClause, this.questions, this.applyForm.getRawValue())) {
              question.QuestionTextAlt = cond.AlternativeQuestionText ? cond.AlternativeQuestionText : " ";
              this.newRelicService.addPageAction('Question Variations Processed', { status: 'processed', questionName: QuestionName, appId: this.appId });
              return;
            }
          });
        }
  
        // Populate OptionAltText based on QuestionOptionVariations ConditionalClause
        if (question.QuestionOptions) {
          question.QuestionOptions.forEach(cond => {
            if (cond.QuestionOptionVariations) {
              cond.QuestionOptionVariations.forEach((variation) => {
                if (this.processorService.analyzeConditionalArray(variation.ConditionalClause, this.questions, this.applyForm.getRawValue())) {
                  cond.OptionAltText = variation.AlternativeQuestionOptionText ? variation.AlternativeQuestionOptionText : " ";
                  this.newRelicService.addPageAction('Option Variations Processed', { status: 'processed', questionName: QuestionName, appId: this.appId });
                }
              });
            }
          });
        }
      }
  
      let show: boolean = parentShown;
  
      if (show && question.ConditionalClause) {
        show = this.processorService.showConditionalQuestion(question, this.questions, this.applyForm.getRawValue());
      }
  
      const field = this.applyForm.get(QuestionName);
      if (field) {
        if (show === false) {
          if (QuestionName !== 'IllustrationSignaturePresent') {
            field.reset();
            field.disable();
          }
        } else {
          if (this.isDemo && (question.QuestionName == 'DriversLicenseNumber' || question.QuestionName == 'BeneficiaryName')) {
            field.disable();
          } else if (!this.isEditable && this.toggleOpenFields) {
            if (this.enabledQuestions.includes(QuestionName)) {
              field.enable();
            } else {
              field.disable();
            }
          } else if (!this.isEditable && !this.toggleOpenFields) {
            field.disable();
          } else {
            field.enable();
          }
        }
        this.newRelicService.addPageAction('Field Visibility Changed', { status: show ? 'enabled' : 'disabled', questionName: QuestionName, appId: this.appId });
      }
  
      this.visibleQuestions[question.QuestionName] = show;
      if (question.QuestionName == 'StateOfIssueRestrictedLabel') {
        this.setResctrictedLabel();
      }
      // set menu question visibility
      const menuDataQ = find(this.sectionMenuData.questions, { 'name': question.QuestionName });
      if (menuDataQ) {
        menuDataQ.visible = show;
      // if (show && question.MultipleResponse) {
      //   return;
      // }
      }
  
      if (question.ChildQuestions && (!question.MultipleResponse || (!show && question.MultipleResponse))) {
        const questionList = offBlockQuestions ? offBlockQuestions : this.questions;
        forEach(question.ChildQuestions, val => {
          const childQuestion = this.qcs.getQuestion(questionList, val.QuestionName);
          this.showConditionalQuestion(childQuestion, show, questionList);
          this.newRelicService.addPageAction('Child Questions Processed', { status: 'processed', questionName: val.QuestionName, appId: this.appId });
        });
      }
  
      this.newRelicService.addPageAction('showConditionalQuestion End', { status: 'completed', questionName: question.QuestionName, appId: this.appId });
    } catch (error) {
      console.log('error', error);
      this.newRelicService.noticeError(error, { appId: this.appId });
    }
  }

  removeEmptyStrings() {
    const formKeys = Object.keys(this.formValueNew);
    for (let i = formKeys.length - 1; i >= 0; i--) {
      const key = formKeys[i];
      const value = this.formValueNew[key];
      if (this.checkIfEmpty(value)) {
        this.formValueNew[key] = null;
      } else if (isArray(value)) {
        value.forEach((arr, index) => {
          forEach(arr, (arrVal, arrKey) => {
            if (arrVal === '' || arrVal == '$') {
              this.formValueNew[key][index][arrKey] = null;
            }
          })
        });
      } else if (isObject(value)) {
        forEach(value, (ObjVal, ObjKey) => {
          if (this.checkIfEmpty(ObjVal)) {
            this.formValueNew[key][ObjKey] = null;
          }
        })
      }
    }
  }

  //checks if value is empty string or $ (default for currency)
  checkIfEmpty(value) {
    return value === '' || value == '$';
  }

  applyDefaults() {
    //go to error if there is an error on the screen
    if (!this.processorService.noValidation() && !this.applyForm.valid && this.isEditable) {
      this.processorService.goToError();
      return;
    }

    forEach(this.defaultValues, (dval, dkey) => {
      if (this.applyForm.controls[dkey] && this.applyForm.controls[dkey].value === dval) {
        this.applyForm.controls[dkey].reset();
      }
      if (this.applyForm.controls[dkey] && (!this.applyForm.controls[dkey].valid || this.applyForm.controls[dkey].value === null)) {
        const questionObj = this.questions.find(x => x.QuestionName === dkey);
        if (questionObj.DefaultValueConditional) {
          if (!this.processorService.showQuestion(questionObj.DefaultValueConditional, this.questions, this.applyForm.getRawValue(), null)) {
            delete this.defaultValues[dkey];
            return;
          }
        };
        if (!this.applyForm.controls[dkey].value) {
          cloneDeep(this.applyForm.controls[dkey]).enable();
          this.applyForm.controls[dkey].patchValue(dval);
        }
        delete this.defaultValues[dkey];
      };
    });

    // exit early and avoid diving into formGroups and formArrays if all defaultValues have been added (most blocks don't need the following)
    if (Object.keys(this.defaultValues).length === 0) {
      return;
    }

    forEach(this.applyForm.controls, (value, name) => {
      // stop loop if the defaultValues run out
      if (Object.keys(this.defaultValues).length > 0) {
        if (value.hasOwnProperty('controls')) {
          // formArrays
          if (isArray(value['controls'])) {
            forEach(this.applyForm.controls[name], (resp, index) => {
              if (!this.applyForm.controls[name]['controls'][index].hasOwnProperty('controls')) {
                // only interested in multipleresponse formArrays, not these multiselects
              } else {
                forEach(this.defaultValues, (dval, dkey) => {
                  const fullQuestion = this.qcs.getQuestion(this.questions, dkey);
                  if (this.applyForm.controls[name]['controls'][index]['controls'][dkey] && (!this.applyForm.controls[name]['controls'][index]['controls'][dkey].valid || this.applyForm.controls[name]['controls'][index]['controls'][dkey].value === null)) {
                    if (fullQuestion.DefaultValueConditional) {
                      if (!this.processorService.showQuestion(fullQuestion.DefaultValueConditional, this.questions, this.applyForm.value, null)) {
                        delete this.defaultValues[dkey];
                        return;
                      }
                    }
                    if (this.applyForm.controls[name]['controls'][index]['controls'][dkey] && !this.applyForm.controls[name]['controls'][index]['controls'][dkey].value) {
                      cloneDeep(this.applyForm.controls[name]['controls'][index]['controls'][dkey]).enable();
                      this.applyForm.controls[name]['controls'][index]['controls'][dkey].patchValue(dval);
                    }
                  }
                });
              }
            });
          } else {
            // nested formGroups (name, address, etc)
            forEach(this.defaultValues, (dval, dkey) => {
              const fullQuestion = this.qcs.getQuestion(this.questions, dkey);
              if (this.applyForm.controls[name]['controls'][dkey] && (!this.applyForm.controls[name]['controls'][dkey].valid || this.applyForm.controls[name]['controls'][dkey].value === null)) {
                if (fullQuestion.DefaultValueConditional) {
                  if (!this.processorService.showQuestion(fullQuestion.DefaultValueConditional, this.questions, this.applyForm.value, null)) {
                    delete this.defaultValues[dkey];
                    return;
                  }
                };
                if (this.applyForm.controls[name]['controls'][dkey] && !this.applyForm.controls[name]['controls'][dkey].value) {
                  cloneDeep(this.applyForm.controls[name]['controls'][dkey]).enable();
                  this.applyForm.controls[name]['controls'][dkey].patchValue(dval);
                }
              }
            });
          }
        }
      };
    });
  }


  submitBlock(direction: string) {
    try {
      this.newRelicService.addPageAction('submitBlock Start', { status: 'started', direction, appId: this.appId });
  
      // stop valueChanges detection from firing due to defaultValue injection
      this.stopCheck = true;
  
      // erase stored formValue used in form change detection
      this.formVal = null;
  
      // sets navigationService observable to hide menu when menu nav is clicked
      if (direction !== 'fwd' && direction !== 'back' && direction !== 'exit') {
        this.navigationService.setHideMenu(true);
      }
  
      const { value, valid, controls, disabled } = this.applyForm;
      // check for blank form and prevent submission
      if (this.processorService.isFormBlank(this.applyForm.getRawValue())) {
        console.log('form is blank... nothing to save here');
        this.checkmarkMenu(valid || disabled ? true : null);
        if (direction !== 'exit') {
          this.changeBlock(controls, direction, true);
        }
        this.newRelicService.addPageAction('submitBlock Blank Form', { status: 'blank form', appId: this.appId });
        return;
      }
  
      // skips defaultValue injection for Medical Condition Details, because it is handled in medical-conditions.component.ts
      if (this.sectionBlock !== 'Part2SECTIONCMedicalConditions2') {
        // sort through form object to apply defaultValues without overwriting user input
        this.applyDefaults();
        this.applyForm.markAllAsTouched();
        this.newRelicService.addPageAction('submitBlock Apply Defaults', { status: 'defaults applied', appId: this.appId });
      }
  
      if (this.sectionBlock === 'VULFundAllocation') {
        if (!this.qs.getVulValidity()) {
          this.newRelicService.addPageAction('submitBlock VUL Invalid', { status: 'vul invalid', appId: this.appId });
          return false;
        }
      }
  
      forEach(this.hiddenQuestions, (hidden) => {
        // Removes validation for any intentionally suppressed questions in the block
        if (this.applyForm.get(hidden) instanceof FormGroup || this.applyForm.get(hidden) instanceof FormArray) {
          const group = this.applyForm.get(hidden) as FormGroup;
          Object.keys(group.controls).forEach(kee => {
            const f = group.controls[kee];
            f.disable();
          });
        }
  
        if (this.applyForm.get(hidden)) {
          this.applyForm.get(hidden).setErrors(null);
        }
      });
      this.applyForm.updateValueAndValidity();
    // this.checkmarkMenu(this.applyForm.valid || this.applyForm.disabled ? true : null);
  
      if (this.processorService.noValidation()) {
        this.changeBlock(controls, direction);
      } else {
      // console.log('this.applyForm.valid: ', this.applyForm.valid);
      // console.log('this.isEditable: ', this.isEditable);

        if (!this.applyForm.valid && this.isEditable) {
          this.setDemoValues();
          this.invalidFormGroupsExceptRequired = [];
        // moveto errors
        // console.log('right before go to error call');
          this.processorService.goToError();
  
          const invalidInput: any = pickBy(controls, (val, key) => val.invalid);
        // console.log('invalid fields:', invalidInput);
          const invalidInputKeys: any = Object.keys(invalidInput);
  
          const invalidFormGroups: any = Object.keys(pickBy(controls, (val, key) => (val['controls']) !== undefined));
        // console.log('invalid form groups:', invalidFormGroups);
          const invFormGroup = [];
          for (let i = 0; i < invalidFormGroups.length; i++) {
            if (invalidInputKeys.includes(invalidFormGroups[i])) {
              invFormGroup.push(invalidFormGroups[i]);
            }
          }

        // get invalid form controls within form groups
  
          invFormGroup.forEach(element => {
            const invalidInputControls = Object.keys(invalidInput[element].controls);
            invalidInputControls.forEach(control => {
              if (invalidInput[element].controls[control].errors ? (!Object.keys(invalidInput[element].controls[control].errors).includes('required') && !Object.keys(invalidInput[element].controls[control].errors).includes('minOneSelection')) : null) {
              // console.log('this is a bad element: ', Object.keys(invalidInput).find(key=> invalidInput[key] === invalidInput[element]));
                const badFormGroup = Object.keys(invalidInput).find(key => invalidInput[key] === invalidInput[element]);
                this.invalidFormGroupsExceptRequired.push(badFormGroup);
              }
              const currentControls = invalidInput[element].controls[control].controls ? invalidInput[element].controls[control].controls : invalidInput[element].controls;
              this.generateInvalidControls(currentControls, invalidInput, element);
            });
          });

        // console.log('this.invalidFormGroupsExceptRequired: ', this.invalidFormGroupsExceptRequired);
  
          let invalidInputExceptRequired: any = pickBy(invalidInput, (val, key) => (val.errors ? (!Object.keys(val.errors).includes('required') && !Object.keys(val.errors).includes('minOneSelection')) : null) || this.invalidFormGroupsExceptRequired.includes(key));
  
          invalidInputExceptRequired = Object.keys(invalidInputExceptRequired);
        // console.log('invalidInputExceptRequired:', invalidInputExceptRequired);
  
          if (invalidInputExceptRequired.length > 0) {
          // console.log('invalidInputExceptRequired:', invalidInputExceptRequired);
            return false;
          }
          if (invalidInputExceptRequired.length == 0 && this.sectionBlock === "SECTIONCBeneficiaryInformation" && value['PrimaryTotalAllocation'] < 100) {
            this.newRelicService.addPageAction('submitBlock Invalid Allocation', { status: 'invalid allocation', appId: this.appId });
            return false;
          }

        }
        const NIGOLabelList = [
          "NotReplacingNIGOWarning",
          "YesReplacingDetailsNIGOWarning",
          "NotReplacingDetailsNIGOWarning",
          "TempAgreementBillingNIGO",
          "YesReplacingNIGOWarning"
        ];
        if (this.isEditable) {
          this.appState$.pipe(first()).subscribe((state: any) => {
            state.content.menuData.find(x => x.name === this.sectionBlock).valid = this.applyForm.valid ? true : null;
            NIGOLabelList.forEach(label => {
              if (this.applyForm.controls[label]) {
                if (this.applyForm.controls[label].enabled) {
                  this.checkmarkMenu(false);
                }
              }
            });
          });
        }
  
        // proceed to next section
        this.changeBlock(controls, direction);
        this.newRelicService.addPageAction('submitBlock Change Block', { status: 'block changed', direction, appId: this.appId });
  

      //check for mult policies
        if (this.sectionBlock === "SECTIONFExistingReplacementPendingInsuranceInformation" && this.userRole.name === "Agent") {
          this.appState$.pipe(first()).subscribe((state: any) => {
            const flexPremAmt = state["content"]["SECTIONDCoverageDetails"]["FlexiblePremiumProductsBaseAmount"] ? Number(state["content"]["SECTIONDCoverageDetails"]["FlexiblePremiumProductsBaseAmount"].toString().replace(/[^0-9.-]+/g, "")) : 0;
            const flexSuppPremAmt = state["content"]["SECTIONDCoverageDetails"]["FlexiblePremiumProductsSupplementalAmount"] ? Number(state["content"]["SECTIONDCoverageDetails"]["FlexiblePremiumProductsSupplementalAmount"].toString().replace(/[^0-9.-]+/g, "")) : 0;
            const termAmt = state["content"]["SECTIONDCoverageDetails"]["TermFaceAmount"] ? Number(state["content"]["SECTIONDCoverageDetails"]["TermFaceAmount"].toString().replace(/[^0-9.-]+/g, "")) : 0;
            const limit = termAmt + flexPremAmt + flexSuppPremAmt;
            const fullAmt = state["content"]["SECTIONFExistingReplacementPendingInsuranceInformation"]["TotalNewCoverageToAccept"] ? Number(state["content"]["SECTIONFExistingReplacementPendingInsuranceInformation"]["TotalNewCoverageToAccept"].toString().replace(/[^0-9.-]+/g, "")) : 0;
            if (fullAmt > limit) {
              const dialogConfig = new MatDialogConfig();
              const modalRef = this.disclosure.open(ModalComponent, {
                disableClose: true,
                closeOnNavigation: true,
                data: {
                  size: '',
                  // Array of screens
                  screens: [
                    {
                      show: true,
                      exit_btn: true,
                      content: [
                        {
                          type: 'title',
                          content: 'Your progress has been saved',
                          class: 'modal-title-bold modal-title-centered',
                          parentClass: 'modal-extra-padding'
                        },
                        {
                          type: 'text',
                          content: 'If you are submitting multiple applications for the same proposed insured through this',
                          class: this.appConstants.modalParagraphDefault,
                          parentClass: this.appConstants.modalTextWrapperCentered
                        },
                        {
                          type: 'text',
                          content: 'eApp platform, please wait 2 business days after proposed insured\'s and your signatures',
                          class: this.appConstants.modalParagraphDefault,
                          parentClass: this.appConstants.modalTextWrapperCentered
                        },
                        {
                          type: 'text',
                          content: 'are complete on the first application before you start the second application',
                          class: this.appConstants.modalParagraphDefault,
                          parentClass: this.appConstants.modalTextWrapperCentered
                        },
                        {
                          type: 'button_group',
                          buttons: [
                            {
                              type: 'Refresh',
                              label: 'Continue',
                              clickFunction: 'close',
                              class: this.appConstants.buttonPrimary
                            }
                          ]
                        }
                      ]
                    }
                  ]
                }
              });
            }
          });
        }
      }
      this.stopCheck = false;
      this.newRelicService.addPageAction('submitBlock End', { status: 'completed', appId: this.appId });
    } catch (error) {
      console.log('error', error);
      this.newRelicService.noticeError(error, { appId: this.appId });
    }
  }

  generateInvalidControls(currentControls, invalidInput, element) {
    const nestedInvalidInputControls = Object.keys(currentControls);
    nestedInvalidInputControls.forEach(control2 => {
      //console.log(control2);
      if (currentControls[control2]) {
        // console.log(currentControls[control2]);
        if (currentControls[control2].invalid) {
          const checkInvalidRequired = currentControls[control2].errors ? (!Object.keys(currentControls[control2].errors).includes('required') && !Object.keys(currentControls[control2].errors).includes('minOneSelection')) : null;
          if (checkInvalidRequired) {
            //console.log('bad nested control: ', control2);
            const badFormGroup = Object.keys(invalidInput).find(key => invalidInput[key] === invalidInput[element]);
            this.invalidFormGroupsExceptRequired.push(badFormGroup);
          }
        }
        if (currentControls[control2].hasOwnProperty('controls')) {
          //console.log('hello?', currentControls[control2]);
          this.generateInvalidControls(currentControls[control2].controls, invalidInput, element);

        }
      }
    });
  }
  changeBlock(controls: any, direction: string, doNotWrite: boolean = false) {

    let changedStatus = false;
    if (this.sectionMenuData.valid != this.oldStatus) {
      changedStatus = true;
    }

    this.formValueNew = cloneDeep(this.applyForm.getRawValue());
    this.removeEmptyStrings();

    let isStillEditable = !this.isEditable && this.enabledQuestions.length > 0 ? true : !this.isEditable ? false : true;
    if (this.submitMe) {
      isStillEditable = true;
    }
    // do/don't process data depending on doNotWrite flag and move to a different block
    this.navigationService.takeMeTo(this.formValueNew, doNotWrite ? false : isStillEditable, this.route.snapshot.routeConfig, direction, changedStatus);
  }

  setDemoValues() {
    if (this.isDemo) {
      if (this.sectionBlock == 'SECTIONAProposedInsured') {
        // this.applyForm.controls['DriversLicense'].setValue('true');
        this.visibleQuestions['DriversLicenseState'] = true;
        this.applyForm.controls['DriversLicenseState'].enable();
        this.visibleQuestions['DriversLicenseNumber'] = true;
        // this.applyForm.controls['DriversLicenseNumber'].enable();
        this.applyForm.controls['DriversLicenseNumber'].disable();

        this.applyForm.controls['DriversLicenseState'].valueChanges.pipe(takeUntil(this._onDestroy)).subscribe(value => {
          this.applyForm.controls['DriversLicenseNumber'].enable();
          this.applyForm.get('DriversLicenseNumber').setValue(this.getDemoDriversLicense(value));
          this.applyForm.controls['DriversLicenseNumber'].disable();
        });
      }
    }
  }

  getDemoDriversLicense(stateLicense) {
    if (stateLicense == 'AL' || stateLicense == 'PA' || stateLicense == 'SD' || stateLicense == 'TX' || stateLicense == 'UT' || stateLicense == 'VT' || stateLicense == 'TN' || stateLicense == 'OH') {
      return '12345678';
    } else if (stateLicense == 'AK' || stateLicense == 'DE' || stateLicense == 'DC' || stateLicense == 'ME' || stateLicense == 'GA' || stateLicense == 'LA' || stateLicense == 'NC' || stateLicense == 'OR' || stateLicense == 'PR' || stateLicense == 'RI' || stateLicense == 'SC' || stateLicense == 'WV' || stateLicense == 'WA') {
      return '1234567';
    } else if (stateLicense == 'AZ' || stateLicense == 'AR' || stateLicense == 'CO' || stateLicense == 'CT' || stateLicense == 'HI' || stateLicense == 'ID' || stateLicense == 'IN' || stateLicense == 'IA' || stateLicense == 'KS' || stateLicense == 'KY' || stateLicense == 'MA' || stateLicense == 'MS' || stateLicense == 'MO' || stateLicense == 'MT' || stateLicense == 'NV' || stateLicense == 'NM' || stateLicense == 'NY' || stateLicense == 'ND' || stateLicense == 'OK' || stateLicense == 'VA' || stateLicense == 'WY') {
      return '123456789';
    } else if (stateLicense == 'FL' || stateLicense == 'IL' || stateLicense == 'MD' || stateLicense == 'MI' || stateLicense == 'MN') {
      // 1 Alpha 12 numeric
      return 'A123456789123';
    } else if (stateLicense == 'GU' || stateLicense == 'NJ') {
      // 1 Alpha 14 numeric
      return 'A12345678912345';
    } else if (stateLicense == 'CA' || stateLicense == 'NE') {
      // 1 Alpha 7 numeric
      return 'A1234567';
    } else if (stateLicense == 'WI') {
      // 1 Alpha 13 numeric
      return 'A1234567891234';
    } else if (stateLicense == 'NH') {
      // 3 Alpha 8 numeric
      return 'ABC12345678';
    } else {
      return '12345678';
    }
  };

  checkUpdatePolicyOwnerInformation(changedQuestion, newFormVal) {
    if (this.policyOwnerQuestions.includes(changedQuestion)) {
      console.log(changedQuestion, newFormVal);
      if (changedQuestion == 'PolicyOwnerInsured' && newFormVal[changedQuestion] && newFormVal['PolicyOwnerInformation']) {
        if (newFormVal[changedQuestion] == 'SoleOwner' && newFormVal['PolicyOwnerInformation'] instanceof Array) {
          if (this.applyForm.controls && this.applyForm.controls['PolicyOwnerInformation'] && this.applyForm.controls['PolicyOwnerInformation']['controls']) {
            this.applyForm.controls['PolicyOwnerInformation']['controls'].splice(1);
          }
        }
      } else if (changedQuestion == 'PolicyOwnerInsuredNo' && newFormVal[changedQuestion] && newFormVal['PolicyOwnerInformation']) {
        if (newFormVal[changedQuestion] == 'false' && newFormVal['PolicyOwnerInformation'] instanceof Array) {
          if (this.applyForm.controls && this.applyForm.controls['PolicyOwnerInformation'] && this.applyForm.controls['PolicyOwnerInformation']['controls']) {
            this.applyForm.controls['PolicyOwnerInformation']['controls'].splice(1);
          }
        }
      }
    }
  }
}
function checkValDiff(old: any, val: any, key: string) {
  return (old ? val !== old[key] : true);
}

function checkArrayDiff(old: any, val: any[], key: string) {
  const newKey = !('key' in old);
  let changedValues = false;
  if (old[key]) {
    changedValues = val.some((x, y) => x !== old[key][y]);
  }
  return old && (newKey || changedValues);
  //  return old && (('key' in old) && !val.some((x, y) => x !== old[key][y]));

}

function checkObjectDiff(old: any, val: any, key: string) {
  return old ? (!('key' in old) || Object.keys(val).some(x => val[x] !== old[key][x])) : true;
  //  return old ? ((('key' in old)) && (old[key] ? !(Object.keys(val).some(x => val[x] !== old[key][x])): false)) : true;
}
function checkIULDiff(old: any, val: any, key: string) {
  return key === 'IULPremPaymentAllocation' && (old['IULPremPaymentAllocation'] ? old['IULPremPaymentAllocation']['IULFixedAcct'] !== val['IULFixedAcct'] : false);
}


function checkNonNullObject(val: any[]) {
  return val[0] ? isObject(val[0]) && val[0] != null : false;
}

